import { render, staticRenderFns } from "./partner-login.vue?vue&type=template&id=c079992a&scoped=true&lang=pug"
import script from "./partner-login.vue?vue&type=script&lang=js"
export * from "./partner-login.vue?vue&type=script&lang=js"
import style0 from "./partner-login.vue?vue&type=style&index=0&id=c079992a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c079992a",
  null
  
)

export default component.exports